<template>
  <v-date-picker 
    v-model="datum" 
    mode="single" 
    popover-visibility="focus"
  >
    <b-input-group slot-scope="props">
      <div class="input-group-prepend">
        <span class="input-group-text">
          <i class="fa fa-calendar" />
        </span>
      </div>
      <b-form-input
        :value="props.inputValue"
        :placeholder="placeholder"
        type="text"
        @change.native="props.updateValue($event.target.value)"
      />
    </b-input-group>
  </v-date-picker>
</template>
<script>
import { setupCalendar, DatePicker } from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";
import moment from "moment";

setupCalendar({
  firstDayOfWeek: 2 // Monday
});

export default {
  name: "DateInput",
  components: {
    "v-date-picker": DatePicker
  },
  props: {
    date: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Kies een datum'
    }
  },
  data() {
    return {
      datum: moment(this.date).isValid() ? moment(this.date).toDate() : null
    };
  },
  watch: {
    datum: function(newVal, oldVal) {
      console.log(oldVal);
      console.log(newVal);
      this.$emit("date-changed",newVal);
    }
  },
  methods: {
    onUpdate(localProps, value) {
      console.log(value);
      localProps.updateValue(value);
    }
  }
};
</script>